import { clearTokens } from "@src/app/authSlice";
import { clearHeaderState } from "@src/app/headersSlice";
import { AppDispatch, persistor } from "@src/app/store";
import {
  clearUserDetails,
  setGlobalState,
  setTheme,
} from "@src/app/globalSlice";
import { clearVideoCache } from "@src/components/video-downloader/GlobalVideoDownloader";
import { resetVideoDownload } from "@src/app/videoDownloadSlice";

type LogoutCleanupOptions = {
  theme?:
    | "website-theme"
    | "app-theme"
    | "editor-dark-theme"
    | "editor-light-theme";
};

export const clearLogoutSession = (
  dispatch: AppDispatch,
  options: LogoutCleanupOptions = {},
) => {
  clearVideoCache();
  dispatch(resetVideoDownload());
  persistor.purge();
  dispatch({ type: "RESET_STATE" });
  dispatch(clearUserDetails());
  dispatch(clearHeaderState());
  dispatch(clearTokens());
  dispatch(setGlobalState({ loginStatus: "login" }));

  if (options.theme) {
    dispatch(setTheme(options.theme));
  }

  sessionStorage.clear();
};
